(() => {
  const STORAGE_KEY = "shipxpert_recently_viewed";

  function getStore() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  function setStore(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, 20)));
  }

  function money(cents, currency) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency || "GBP",
      }).format(amount);
    } catch (err) {
      return `GBP ${amount.toFixed(2)}`;
    }
  }

  function cardTemplate(product, currency) {
    const image =
      product.images && product.images.length ? product.images[0] : "";
    const compareAt = product.compare_at_price
      ? `<s class=\"price-item price-item--regular\">${money(product.compare_at_price, currency)}</s>`
      : "";
    return `
      <li class="grid__item">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media">
            <div class="card__inner ratio" style="--ratio-percent: 100%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${image}" alt="${product.title}" loading="lazy" width="600" height="600">
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5"><a href="/products/${product.handle}" class="full-unstyled-link">${product.title}</a></h3>
                <div class="card-information">
                  <span class="caption-large light">${product.vendor || ""}</span>
                  <div class="price">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden">Regular price</span>
                        <span class="price-item price-item--regular">${money(product.price, currency)}</span>
                        ${compareAt}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>`;
  }

  async function renderSection(section) {
    const handle = section.dataset.productHandle;
    const limit = Number(section.dataset.limit || 4);
    const currency = section.dataset.currency || "GBP";
    const grid = section.querySelector("[data-recently-viewed-grid]");
    if (!grid || !handle) return;

    const store = getStore().filter((h) => h !== handle);
    setStore([handle, ...store]);

    const recent = getStore()
      .filter((h) => h !== handle)
      .slice(0, limit);
    if (!recent.length) return;

    const results = [];
    for (const h of recent) {
      try {
        const response = await fetch(`/products/${h}.js`);
        if (!response.ok) continue;
        const product = await response.json();
        results.push(product);
      } catch (err) {
        // Ignore product fetch failures.
      }
    }

    if (!results.length) return;

    grid.innerHTML = results.map((p) => cardTemplate(p, currency)).join("");
    grid.hidden = false;
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-recently-viewed]").forEach((section) => {
      renderSection(section);
    });
  });
})();
